import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `orders/${args?.id}`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'orders',
      method: 'get',
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const updateStatus = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `orders/status/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Status Updated Sucessfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

export default {
  find,
  list,
  updateStatus,
}
